import { useCallback } from 'react';
import { getDateForIms } from 'js/hooks/useFormatter/helpers';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useUpdatePlayerInfo = () => {
    const send = useGenericSend();

    return useCallback(async (request: Types.IUpdatePlayerInfoRequestData) => {
        const { data: {
            playerCode, actions
        } } = await send<Types.TUpdatePlayerInfoSendRequestData, Types.IUpdatePlayerInfoResponseData>({
            ID: 33045,
            errorLevel: 1,
            responses: [33006, 31008],
            description: 'Update Player Info',
            changeTimestamp: getDateForIms(new Date()),
            ...request
        });

        return { playerCode, actions };
    }, [send]);
};
